module.exports = __webpack_public_path__ + "img/heart.a288570e.svg";